import aa from 'search-insights';

const ALGOLIA_QUERY_ID_STORAGE_NAME = 'algolia_search_query_id';
const ALGOLIA_USER_TOKEN_STORAGE_NAME = 'algolia_user_token';

const _getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

const _setCookie = (name, value) => {
  document.cookie = `${name}=${value}; path=/`;
};
export const setAlgoliaQueryID = (queryId) => {
  try {
    window.sessionStorage.setItem(ALGOLIA_QUERY_ID_STORAGE_NAME, queryId);
  } catch (error) {
    console.log(error);
  }
};

export const getAlgoliaQueryId = () => {
  try {
    const queryId = window.sessionStorage.getItem(
      ALGOLIA_QUERY_ID_STORAGE_NAME
    );

    return queryId;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// Function to create random user token if one isn't found
export const createRandomUserToken = () => {
  return Array.from(Array(20), () =>
    Math.floor(Math.random() * 36).toString(36)
  ).join('');
};

export const getUserToken = () => {
  const userToken = _getCookie(ALGOLIA_USER_TOKEN_STORAGE_NAME);
  if (!userToken) {
    const newUserToken = createRandomUserToken();
    _setCookie(ALGOLIA_USER_TOKEN_STORAGE_NAME, newUserToken);
    return newUserToken;
  }
  return userToken;
};

export const storeAlgoliaConfigInLocalStorage = () => {
  const config = {
    app_id: window.ALGOLIA_APPLICATION_ID,
    search_api_key: window.ALGOLIA_SEARCH_KEY,
    index_name: window.ALGOLIA_INDEX_NAME,
    user_token: getUserToken(),
  };

  localStorage.setItem('algolia_config', JSON.stringify(config));
};

export const initAlgoliaTracking = async () => {
  aa('init', {
    appId: window.ALGOLIA_APPLICATION_ID,
    apiKey: window.ALGOLIA_SEARCH_KEY,
    useCookie: true, // TODO: Handle the false state when the user reject the cookies
    userToken: getUserToken(),
    // authenticatedUserToken: window.ANALYTICS_CUSTOMER_ID,
  });

  storeAlgoliaConfigInLocalStorage();

  // Init the global search attribution tracking function
  window.trackSearchAttribution = trackSearchAttribution;
};

export const trackAlgoliaEvent = (name, payload) => {
  aa(name, payload);
};

export const trackClickedObjectAfterSearch = ({
  eventName,
  index,
  queryID,
  objectIDs,
  positions,
}) => {
  trackAlgoliaEvent('clickedObjectIDsAfterSearch', {
    eventName,
    index: index || window.ALGOLIA_INDEX_NAME,
    queryID,
    objectIDs,
    positions,
  });
};

export const trackSearchAttribution = (query_id, variant_id, product_id) => {
  const clickData = {
    eventName: 'Added to cart',
    index: window.ALGOLIA_INDEX_NAME,
    queryID: query_id,
    objectIDs: [variant_id],
    productId: product_id,
  };

  try {
    const localStorageKey = 'algolia_analytics_clicked_objects'; // Key

    // Get any data previously stored
    const previousClickItemsString =
      localStorage.getItem(localStorageKey) || '[]';
    const previousClickItems = JSON.parse(previousClickItemsString);

    // Add the current products data to local storage
    previousClickItems.push(clickData);
    localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));
  } catch (error) {
    console.error(error);
  }
};
